"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRuntime = getRuntime;
exports.setRuntime = setRuntime;
var _configurable = require("./configurable");
var _nreum = require("../window/nreum");
var _runtime = require("../constants/runtime");
var _env = require("../constants/env.npm");
/**
 * Module level count of harvests. This property will auto-increment each time it is accessed.
 * @type {number}
 */
let harvestCount = 0;
const readonly = {
  buildEnv: _env.BUILD_ENV,
  distMethod: _env.DIST_METHOD,
  version: _env.VERSION,
  originTime: _runtime.originTime
};
const model = {
  customTransaction: undefined,
  disabled: false,
  isolatedBacklog: false,
  loaderType: undefined,
  maxBytes: 30000,
  onerror: undefined,
  origin: '' + _runtime.globalScope.location,
  ptid: undefined,
  releaseIds: {},
  /** Agent-specific metadata found in the RUM call response. ex. entityGuid */
  appMetadata: {},
  session: undefined,
  denyList: undefined,
  timeKeeper: undefined,
  obfuscator: undefined
};
const _cache = {};
function getRuntime(id) {
  if (!id) throw new Error('All runtime objects require an agent identifier!');
  if (!_cache[id]) throw new Error("Runtime for ".concat(id, " was never set"));
  return _cache[id];
}
function setRuntime(id, obj) {
  if (!id) throw new Error('All runtime objects require an agent identifier!');
  _cache[id] = {
    ...(0, _configurable.getModeledObject)(obj, model),
    ...readonly
  };
  if (!Object.hasOwnProperty.call(_cache[id], 'harvestCount')) {
    // Harvest count needs to be added as a getter so the variable is updated each time it is accessed
    Object.defineProperty(_cache[id], 'harvestCount', {
      get: () => ++harvestCount
    });
  }
  const agentInst = (0, _nreum.getNREUMInitializedAgent)(id);
  if (agentInst) agentInst.runtime = _cache[id];
}